export const refreshApplication = async () => {
  try {
    const registration = await navigator.serviceWorker?.getRegistration();
    if (registration) {
      const changed = new Promise((resolve) => {
        const done = () => resolve();
        navigator.serviceWorker.addEventListener("controllerchange", done, { once: true });
        setTimeout(done, 2000);
      });
      await registration.update();
      if (registration.waiting) registration.waiting.postMessage({ type: "SKIP_WAITING" });
      await changed;
    }
    if ("caches" in globalThis) {
      const keys = await caches.keys();
      await Promise.all(keys.filter((key) => key.startsWith("oche-mobile-")).map((key) => caches.delete(key)));
    }
  } catch {
    /* Reload still refreshes network-first app assets. */
  }
  const url = new URL(globalThis.location.href);
  url.searchParams.set("appRefresh", Date.now().toString());
  globalThis.location?.replace(url);
};

export const urlBase64ToUint8Array = (value) => {
  const padding = "=".repeat((4 - (value.length % 4)) % 4);
  const raw = atob((value + padding).replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from([...raw].map((character) => character.charCodeAt(0)));
};

export const fullAppVersion = String(__APP_VERSION__);

export const appVersionParts = fullAppVersion.split("-");

export const appVersion = /^\d+$/.test(appVersionParts[0])
  ? appVersionParts[0]
  : appVersionParts[0] === "ci" && /^\d+$/.test(appVersionParts[1])
    ? `ci-${appVersionParts[1]}`
    : fullAppVersion;

export const scoresheetV2Enabled =
  String(
    import.meta.env.VITE_SCORESHEET_V2_ENABLED || "false",
  ).toLowerCase() === "true";

export const scoreboardBaseUrl = (
  import.meta.env.VITE_SCOREBOARD_BASE_URL || "https://score.ocheleague.com"
).replace(/\/$/, "");
